class FieldBehaviorsCtrl {
  constructor($scope, $timeout, $window, FEService, SchemaService, AuthService, TemplateService, EventService) {
    'ngInject';
    // Current TODO's:
    // - Prevent Logic conflicts
    // - Delete DO's on Token delete (Render Service)

    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.ss = SchemaService;
    this.as = AuthService;
    this.ts = TemplateService;
    this.es = EventService;
    this.fe = FEService;

    this.fSchema = {};
    this.newBehavior = {};
    this.availableBehaviors = [];
    this.newConditions = [];
    this.token = {};
    this.behaviors = [];
    this.parentTokens = [];
    this.references = [];
    this.requiredField = false;
    this.readonlyField = false;
    
    this.allPairs = [
      ["Enabled", "Disabled"],
      ["Show", "Hide"],
      ["Require", "Un-Require"]
    ];

    this.columns = [];
    this.newAction = (_records) => this.showForm = true;
  }

  setupBehaviorColumns() {
    this.columns = [
      {
        'key': 'behavior',
        'header': "Behavior",
        'style': { 'text-align': 'center' }
      },
      {
        'key': 'id',
        'header': "When",
        'style': { 'text-align': 'center', 'width': '70%' },
        'format': (id) => {
          const { logic } = this.behaviors.find(b => b.id === id);
          if (logic === 'always') return 'Always';
          const joinAs = logic === "&&" ? "And" : "Or";
          return this.conditions.filter(c => c.behaviorId === id).map(c => {
            const { operation, evaluation } = c;
            const value = evaluation?.value;
            const token = this.ts.tokens.find(t => t.id === c.parentId);
            const reference = this.ts.references.find(r => r.id === token.referenceId);
            let label = `${reference.name}: ${token.fieldSchema.label}`;
            if (token.options?.choice) label += ` - "${token.options.choice.display}"`;
            const isBoolean = this.ts.tokenIsBoolean(this.PROVIDER, token);
            if (operation === "!!" ){
              return `${label} is Not Empty`;
            }
            if (operation === "!" ){
              return `${label} is Empty`;
            }
            if (isBoolean) {
              const checked = ![undefined, null, '', 0, '0', false, 'false'].includes(value);
              return `${label} is "${checked ? 'Checked' : 'Un-checked'}"`;
            }
            const opString = (operation === "==" ) ? 'is' : 'is not';
            return `${label} ${opString} "${value}"`;
          }).join(`<span class="hr-text text-muted"><span>${joinAs}</span></span>`);
        }
      },
      {
        'key': 'id',
        'header': 'Remove',
        'style': { 'text-align': 'center' },
        'format': () => `<i class="fa fa-trash text-muted"></i>`,
        'onClick': value => this.deleteBehavior(value)
      }
    ];
  }
  
  logicChange() {
    if (this.newBehavior.logic === 'always') {
      this.newConditions = [];
    } else if (!this.newConditions.length) {
      this.newConditions = [this.blankCondition(this.templateId, this.childId)];
    }
  }

  async $onInit() {
    this.behaviorType = this.blockId ? "block": "field";
    this.behaviorTypeTitle = (this.blockId ? "Block": "Field") + " Behaviors";
    const waitBindings = this.token ? ["token"]: [];
    [this.PROVIDER, this.td] = await Promise.all([
      this.as.getProviderSettings(),
      this.ts.getTemplateData(),
      this.fe.waitForBindings(waitBindings, this.$scope)
    ]);
    this.setupBehaviorColumns();
    this.templateId = this.ts.templateId;
    if (this.token) this.initiaizeTokenBehaviors();
    if (this.blockId) this.initializeBlockBehaviors();
    this.initNewBehavior();
  }

  initiaizeTokenBehaviors() {
    this.tokenId = this.token.id;
    this.referenceId = this.token.referenceId;
    this.childId = this.tokenId;

    this.behaviors = this.td.template.behaviors.filter(b => b.childId === this.childId);
    this.conditions = this.td.template.conditions.filter(b => b.childId === this.childId);

    const reference = this.ts.references.find(r => r.id === this.referenceId);
    const fieldId = this.fe.getFieldId(this.token.fieldId);
    this.fSchema = this.ss.schemas[reference.tableId]?.fields.find(f => `${f.id}` === `${fieldId}`) || this.token.fieldSchema || {};

    this.isReportField = this.isReportToken(this.token);
    this.pairs = this.isReportField ? [this.allPairs[1], this.allPairs[2]] : this.allPairs;
    this.requiredField = this.fSchema.isRequired && !this.isReportField;
    this.readonlyField = this.fSchema.isReadOnly && !this.isReportField;
    
    this.loadParentTokens();
  }

  isReportToken(token) {
    return this.PROVIDER.reportControls?.includes(token?.control?.type);
  }

  initializeBlockBehaviors() {
    this.pairs = [this.allPairs[1]];
    this.childId = this.blockId;
    this.behaviors = this.td.template.behaviors.filter(b => b.childId === this.childId);
    this.conditions = this.td.template.conditions.filter(b => b.childId === this.childId);

    this.requiredField = false;
    this.readonlyField = false;

    this.loadParentTokens();
  }

  loadParentTokens() {
    this.parentTokens = [];
    const uniqueFields = [...new Set(this.ts.tokens.map(t => {
      const choice = t.options?.choice;
      return JSON.stringify({ referenceId: t.referenceId, fieldId: t.fieldId, choice });
    }))];
    uniqueFields.forEach(uF => {
      const {fieldId, referenceId} = JSON.parse(uF);
      const tokens = this.ts.tokens.filter(t => 
        t.fieldId == fieldId 
          && t.referenceId == referenceId
          && !this.parentTokens.some(pt => pt.id === t.id)
      );
      tokens.forEach(token => {
        const ref = this.ts.references.find(ref => ref.id === token.referenceId);
        const fSchema = token.fieldSchema;
        if (!fSchema) return;
        let label = `${ref.name}: ${fSchema.label}`;
        if (token.options?.choice) label += ` - "${token.options.choice.display}"`;
        const tokenType = fSchema.fieldType;
        this.parentTokens.push(Object.assign({}, token, { label }, { tokenType }));
      });
    });
    
    this.parentTokens = this.parentTokens.filter(token => {
      return token.id !== this.tokenId && this.isValidBehaviorParent(token);
    }).sort((a, b) => { return a.label < b.label ? -1 : a.label > b.label ? 1 : 0 });
  }

  isValidBehaviorParent(token) {
    return this.PROVIDER.behaviorFields.includes(token.tokenType)
      || this.ts.tokenIsMultiCheckboxOption(token);
  }

  normalizeMultiCheckboxEvaluation(condition, parentToken) {
    if (!this.ts.tokenIsMultiCheckboxOption(parentToken)) return;
    const choice = parentToken.options.choice.value;
    const checked = String(condition.evaluation?.value || '').split(parentToken.control.delimiter).includes(choice);
    condition.evaluation = Object.assign({}, condition.evaluation, { value: checked ? 1 : 0 });
  }
  
  onFieldSelected(condition) {
    const { parentId } = condition;
    // $timeout to reset field
    condition.parentId = null;
    this.$timeout(() => {
      condition.parentId = parentId;
      const { label, referenceId, fieldId } = this.parentTokens.find(t => t.id === parentId);
      const evaluation = undefined;
      Object.assign(condition, { evaluation, label, referenceId, fieldId });
    });
  }

  cancel() {
    this.initNewBehavior();
    this.showForm = false;
  }

  parentToken(tokenId){
    return this.ts.tokens.find(t => t.id == tokenId);
  }

  initNewBehavior() {
    this.newBehavior = {
      templateId: this.templateId,
      realm: this.td.template.realm,
      provider: this.td.template.provider,
      childId: this.childId,
      childType: this.behaviorType,
      logic: "&&",
      behavior: this.isReportField ? "Show" : "Enabled"
    };
    this.newConditions = [this.blankCondition(this.templateId, this.childId)];
    this.updateAvailableBehaviors();
  }

  addBehavior(behavior, conditions) {
    behavior = this.ts.initializeNewObject(behavior);
    this.td.template.behaviors.push(behavior);
    conditions.forEach(condition => {
      condition.behaviorId = behavior.id;
      if (condition.evaluation === undefined) { 
        const reference = this.ts.references.find(r => r.id == condition.referenceId);
        condition.evaluation = this.ss.schemas[reference.tableId]
          .fields.find(f => f.id == condition.fieldId)?.initValue;
      }
      const parentToken = this.ts.tokens.find(t => t.id === condition.parentId);
      const formatter = parentToken?._formatter;
      if (formatter) condition.evaluation.value = formatter.getBehaviorValue(condition.evaluation.value);
      this.normalizeMultiCheckboxEvaluation(condition, parentToken);
      condition = this.ts.initializeNewObject(condition);
      this.td.template.conditions.push(condition);
    });
    
    this.applyChanges();
  }

  applyChanges() {
    this.showForm = false;
    this.initNewBehavior();
    this.updateTemplateData();
    this.updateAvailableBehaviors();
  }

  deleteBehavior(behaviorId) {
    const msg = "Are you sure you wish to remove this Behavior?";
    if (!!behaviorId && this.$window.confirm(msg)) {
      this.td.template.behaviors = this.ts.behaviors.filter(b => b.id !== behaviorId);
      this.td.template.conditions = this.ts.conditions.filter(c => c.behaviorId !== behaviorId);
      this.updateTemplateData();
      this.updateAvailableBehaviors();
    }
  }

  addCondition() {
    this.newConditions.push(this.blankCondition(this.templateId, this.childId));
  }

  removeCondition(index) {
    this.newConditions.splice(index, 1);
  }

  blankCondition(templateId, childId) {
    return {
      templateId,
      realm: this.td.template.realm,
      provider: this.td.template.provider,
      childId,
      childType: this.behaviorType,
      operation: "=="
    };
  }

  findRef(refId) {
    return this.ts.references.find(r => r.id == refId);
  }

  updateAvailableBehaviors() {
    this.availableBehaviors = this.pairs.reduce((acc, bp, idx) => {
      const available = !this.behaviors.find(b => bp.indexOf(b.behavior) >= 0);
      // Only Show/Hide behaviors are available for READONLY fields (dynamic reports excepted)
      const readOnly = this.fSchema.isReadOnly && (bp[0] !== 'Show') && !this.isReportField;
      // Require/UnRequire behaviors are not available for REQUIRED fields
      const require = this.fSchema.isRequired && (bp[0] === 'Require') && !this.isReportField;
      acc = [...acc, ...(available && !readOnly && !require ? bp : [])];
      return acc;
    }, []);
  }

  updateTemplateData() {
    this.behaviors = this.ts.behaviors.filter(b => b.childId === this.childId);
    this.conditions = this.ts.conditions.filter(b => b.childId === this.childId);

    this.ts.notifyUpdate(["behaviors", "conditions"], this.td);
  }

  copyBehaviors() {
    this.ts.clipBoard.tokenId = this.childId;
  }

  pasteBehaviors() {

    let changed = false;
    const sourceTokenId = this.ts.clipBoard.tokenId;
    const newTokenId = this.childId;
    if (!sourceTokenId || newTokenId == sourceTokenId) return;

    this.ts.behaviors.filter(b => b.childId === sourceTokenId).forEach(b => {
      if (!this.availableBehaviors.includes(b.behavior)) return;
      if (this.behaviorType == 'field' && this.ts.conditions.some(c => c.behaviorId == b.id && c.referenceId == this.token.referenceId && c.fieldId == this.token.fieldId)) return;
      
      const oldBehavior = {
        templateId: b.templateId, realm: b.realm, provider: b.provider,
        childId: newTokenId, logic: b.logic, behavior: b.behavior
      };
      const newBehavior = this.ts.initializeNewObject(oldBehavior);
      this.td.template.behaviors.push(newBehavior);
      changed = true;
      
      this.ts.conditions.filter(c => c.behaviorId === b.id).forEach(c => {
        const oldCondition = {
          templateId: c.templateId, referenceId: c.referenceId, parentId: c.parentId,
          realm: c.realm, provider: c.provider,
          childId: newTokenId, behaviorId: newBehavior.id, 
          operation: c.operation, fieldId: c.fieldId, evaluation: c.evaluation
        };
        const newCondition = this.ts.initializeNewObject(oldCondition);
        this.td.template.conditions.push(newCondition);
      });
    });

    changed && this.applyChanges();
  }

}

export default {
  bindings: {
    token: "<",
    blockId: "<",
  },
  templateUrl: "form-builder/forms/field-behaviors/field-behaviors.component.html",
  controller: FieldBehaviorsCtrl

}